import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remove",
  "use": "remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"remove\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.333.5c-.92 0-1.666.746-1.666 1.667v1.666H1.333a.833.833 0 0 0 0 1.667h.9l.706 8.472A1.667 1.667 0 0 0 4.6 15.5h6.8c.867 0 1.589-.664 1.66-1.528l.707-8.472h.9a.833.833 0 0 0 0-1.667h-1.66a.87.87 0 0 0-.017 0h-1.657V2.167c0-.92-.746-1.667-1.666-1.667H6.333Zm3.334 3.333V2.167H6.333v1.666h3.334ZM12.094 5.5H3.906l.694 8.333h6.8l.694-8.333Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol